import { render, staticRenderFns } from "./baseModel.vue?vue&type=template&id=418850fb&scoped=true"
import script from "./baseModel.vue?vue&type=script&lang=js"
export * from "./baseModel.vue?vue&type=script&lang=js"
import style0 from "./baseModel.vue?vue&type=style&index=0&id=418850fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418850fb",
  null
  
)

export default component.exports